<!--<div class="ui-g-12">
    <img style="width:100%;height:auto;" src="assets/images/dashboard-img.jpg" />
</div>-->
<div class="home-banner">
    <img style="width:100%;height:auto;" src="assets/images/dashboard-img.jpg" />
</div>

